/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/201-upload3': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M7.5 11H0v4h15v-4H7.5zm6.5 2h-2v-1h2v1zM3.5 5l4-4 4 4H9v5H6V5z"/>'
  }
})
